//dependencies
import { useQuery } from "@tanstack/react-query";

//services
import { fetchEasyAddReviews } from "../../services";

export const useEasyAddReviews = (employeeID: string, subjectID: string, query: any, disabled = false) => {
	return useQuery({
		queryKey: ["easy-add-reviews", employeeID, subjectID, query],
		queryFn: async () => {
			const results = await fetchEasyAddReviews(employeeID, subjectID, query);
			return results;
		},
		meta: {
			errorMessage: "Error getting easy add reviews",
		},
		enabled: !disabled,
	});
};
